import React from 'react';
import Bone from 'app/shared/components/Bone';

import {
    Flex,
} from '@zillow/constellation';

// styled components
import {
    StyledContainer,
    StyledPropertyCol,
    StyledPropertyAddress,
} from 'app/shared/components/soh/PropertyRow/StyledComponents';

const PropertyRowSkeleton = () => (
    <StyledContainer>
        <StyledPropertyCol xs={2}>
            <Bone type="box" cover={true} dark={true} />
        </StyledPropertyCol>
        <StyledPropertyCol xs={3}>
            <Bone type="line" dark={true} />
            <StyledPropertyAddress>
                <Flex flex="1">
                    <Bone type="line" dark={true} />
                </Flex>
                <div>
                    <Bone type="line" dark={true} />
                </div>
            </StyledPropertyAddress>
        </StyledPropertyCol>
        <StyledPropertyCol xs={1}>
            <Bone type="line" dark={true} />
        </StyledPropertyCol>
        <StyledPropertyCol xs={1}>
            <Bone type="line" dark={true} />
        </StyledPropertyCol>
        <StyledPropertyCol xs={1}>
            <Bone type="line" dark={true} />
        </StyledPropertyCol>
        <StyledPropertyCol xs={2}>
            <Bone type="line" dark={true} />
        </StyledPropertyCol>
        <StyledPropertyCol xs={1}>
            <Bone type="line" dark={true} />
        </StyledPropertyCol>
        <StyledPropertyCol xs={1}>
            <Bone type="line" dark={true} />
        </StyledPropertyCol>
    </StyledContainer>
);

export default PropertyRowSkeleton;
